export enum ButtonSurface {
  OnPrimary = "onPrimary",
  OnNeutral = "onNeutral",
  OnInverse = "onInverse",
}
